import { render, staticRenderFns } from "./PopupCommon.vue?vue&type=template&id=52a5f3f5&scoped=true"
import script from "./PopupCommon.vue?vue&type=script&lang=js"
export * from "./PopupCommon.vue?vue&type=script&lang=js"
import style0 from "./PopupCommon.vue?vue&type=style&index=0&id=52a5f3f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5f3f5",
  null
  
)

export default component.exports